import React, { Fragment, useEffect } from "react";
import { Col, Row, Slider } from "@kaleyra/emmy";
import { useTranslation } from "react-i18next";
import Styles from './index.module.scss';
import cn from 'classnames';
import { getLanguageFullForm } from "../../../../../../utils";

export type MapStateType = {
    whatsappTemplate: any;
    params: Record<string, any> | undefined;
    inProgress: boolean
};

export type DispatchPropsType = {
    onClose: () => void;
    onLoad: (param: any) => void;
};

type label =
    | 'buttonType'
    | 'headerType'
    | 'websiteUrlType'

const ViewTemplateDetails: React.FC<MapStateType & DispatchPropsType> = ({
    whatsappTemplate,
    params,
    inProgress,
    onClose,
    onLoad,
}) => {

    const { t } = useTranslation();

    const BUTTON_TYPE_OPTIONS: Record<string, string> = {
        '1': t('BLD01575'),
        '2': t('BLD01576'),
        '3': t('chatbotUrl')
    }
    const HEADER_TYPE_OPTIONS: Record<string, string> = {
        '0': t('BLD01577'),
        '1': t('Text'),
        '2': t('BLD01579')
    }
    const WEBSITE_URL_OPTIONS: Record<string, string> = {
        '1': t('BLD01580'),
        '2': t('BLD01581')
    }

    const getOptionLabel = (type: label, key: string) => {
        switch (type) {
            case 'buttonType':
                return BUTTON_TYPE_OPTIONS[key];
            case 'headerType':
                return HEADER_TYPE_OPTIONS[key];
            case 'websiteUrlType':
                return WEBSITE_URL_OPTIONS[key];
            default:
                return '';
        }
    }


    if (Array.isArray(whatsappTemplate)) {
        whatsappTemplate = whatsappTemplate[0] ? whatsappTemplate[0] : {}
        if (whatsappTemplate?.translation) whatsappTemplate.translation = Object.values(whatsappTemplate.translation)[0];
    }

    useEffect(() => {
        onLoad(params)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getBody = () => {
        const { name, translation, template_category_details } = whatsappTemplate
        return <Fragment>
            <div className={Styles.container}>
                <Row>
                    <Col size={6}>
                        {t('mainTitle')}
                    </Col>
                    <Col size={6}>
                        {name}
                    </Col>
                </Row>
                <Row>
                    <Col size={6}>
                        {t('mainLanguage')}
                    </Col>
                    <Col size={6}>
                        {translation?.language ? getLanguageFullForm(translation.language) : "-"}
                    </Col>
                </Row>
                <Row>
                    <Col size={6}>
                        {t('mainCategory')}
                    </Col>
                    <Col size={6}>
                        {template_category_details?.name || "-"}
                    </Col>
                </Row>
                <p className={Styles.subheading}>{t('templateHeader')}</p>
                <Row>
                    <Col size={6}>
                        {t('headerType')}
                    </Col>
                    <Col size={6}>
                        {translation?.header_content_type ? getOptionLabel('headerType', translation.header_content_type) : "-"}
                    </Col>
                </Row>
                <Row>
                    <Col size={6}>
                        {t('headerText')}
                    </Col>
                    <Col size={6}>
                        {template_category_details?.header_content || "-"}
                    </Col>
                </Row>
                <p className={Styles.subheading}>{t('body')}</p>
                <Row>
                    <Col size={12}>
                        {template_category_details?.body || "-"}
                    </Col>
                </Row>
                <p className={Styles.subheading}>{t('templateFooter')}</p>
                <Row>
                    <Col size={6}>
                        {t('footer')}
                    </Col>
                    <Col size={6}>
                        {template_category_details?.footer_content || "-"}
                    </Col>
                </Row>
                <p className={cn(Styles.subheading, Styles.noMargin)}>{t('templateButton')}</p>
                <p className={Styles.subheadingText}>{t('BLD01624')}</p>
                <Row>
                    <Col size={6}>
                        {t('buttonType')}
                    </Col>
                    <Col size={6}>
                        {translation?.button_type ? getOptionLabel('buttonType', translation.button_type) : "-"}
                    </Col>
                </Row>
            </div>
        </Fragment>
    };

    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={true}
            title={t('templateDetails')}
        >
            <div className={Styles.container}>{getBody()}</div>
        </Slider>
    );
}

export default ViewTemplateDetails;